<template>
    <v-card>
       <v-card-text>
          <v-row>
            <v-col cols="12">
              <upload @updatedSrc="getSrc" @updateTitle="getName" :preview="tile"></upload>
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="Name"
                v-model.trim="tile.name"
                type="text"
                placeholder="Name"
                id="name"
              ></v-text-field>
            </v-col>
          </v-row>
      </v-card-text>
    </v-card>
</template>

<script>
// @ is an alias to /src
import { Upload } from "@/components/functionality";

export default {
  name: "AdminArchetypeUpload",
  components: { Upload },
  data() {
    return {
      isValid: true
    };
  },
  props: {
    tile: Object
  },
  methods: {
    getSrc(val) {
      this.tile.src = val;
    },
    getName(val) {
      this.tile.filename = val;
    },
    validateImage(val) {
      this.isValidImage = val;
    }
  }
};
</script>
